import { render, staticRenderFns } from "./DeliveryFee.vue?vue&type=template&id=068993a7&"
import script from "./DeliveryFee.vue?vue&type=script&lang=js&"
export * from "./DeliveryFee.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFee.vue?vue&type=style&index=0&id=068993a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports